import styled, { css } from 'styled-components/macro';
import { Alert } from '@yme/atoms/alert';
import { MiniButton } from '@yme/atoms/mini-button';
import { colorAccentError100, colorAccentSuccess200 } from '@yme/tokens/colors';
import { INDENT } from '@yme/tokens/sizes';
import { fontWeightDefault } from '@yme/tokens/typography';
import { getTextStyles, visibleAnimation } from '@yme/utils/styles';
export const DefaultModalContentStyled = styled.div `
  input {
    ${getTextStyles('Ubuntu', 400, 14, 20)};
  }
  padding: 0;
  margin-bottom: 32px;
`;
export const DefaultModalContentTextStyled = styled.div `
  padding-bottom: ${INDENT.sm};
`;
export const ModalIconWrapperStyled = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: ${INDENT.sm};
`;
export const ModalIconSvgPaddingStyled = styled.div `
  padding: 12px;
  background-color: ${({ isResponseSuccess }) => isResponseSuccess ? colorAccentSuccess200 : colorAccentError100};

  border-radius: 50%;
`;
export const AlertStyled = styled(Alert) `
  animation-name: ${visibleAnimation};
  animation-duration: 0.5s;
`;
export const MiniButtonStyled = styled(MiniButton) `
  ${({ isButtonView }) => {
    if (isButtonView) {
        return css `
        border-radius: 18px;
        padding: 8px 16px;

        ${getTextStyles('Ubuntu', 500, 14, 20)};
        text-transform: uppercase;
        text-decoration: none;
      `;
    }
    return css `
      span {
        ${fontWeightDefault};
      }
    `;
}}
`;
